let isLoaded = false;
let SVGA = {};
import assign from 'lodash/assign';
import isFunction from 'lodash/isFunction';
import room from '../../../lib/room';
import { track, debug } from 'lib';

const loadJs = async () => {
  let res = await Promise.all([import('./howler'), import('./svga')]);
  isLoaded = true;
  assign(SVGA, res[0].default, res[1].default);
  console.log('load js res:', res, SVGA);
  return res;
};

/**
 * 播放 svga
 * @param url
 * @param domId  domId 与 container 选择其一
 * @param container
 * @param onStop
 * @param loops
 * @param fillMode
 * @param contentMode  mode: "Fill" | "AspectFill" | "AspectFit"
 * @param clearsAfterStop
 * @param onReady
 * @returns {Promise<void>}
 */
const play = async ({
  url,
  domId,
  container,
  onStop,
  loops = 1,
  fillMode = 'Forward',
  contentMode,
  clearsAfterStop = true,
  onReady,
}) => {
  if (!isLoaded) {
    await loadJs();
  }
  container =
    typeof domId === 'string' ? document.getElementById(domId) : container;
  let player = new SVGA.Player(container);
  let parser = new SVGA.Parser(container); // 如果你需要支持 IE6+，那么必须把同样的选择器传给

  try {
    parser.load(
      url,
      function (videoItem) {
        player.loops = loops;
        player.clearsAfterStop = clearsAfterStop;
        player.fillMode = fillMode;

        player.setVideoItem(videoItem);

        // console.log('svga videoItem',videoItem)
        let framePlayCount = 0;
        let sTime = Date.now();
        player.onFrame((frame) => {
          framePlayCount++;
          // console.log('svga onFrame',frame)
        });

        player.onFinished(function () {
          player.clearDynamicObjects();
          onStop && onStop();

          // console.log('svga ended',{
          //   frame_count:videoItem.frames,
          //   preset_fps:videoItem.FPS,
          //   play_frame_count:framePlayCount,
          //   play_percentage:(framePlayCount/videoItem.frames*100).toFixed(2),
          // })

          track.send({
            event: 'trace_gift_play',
            event_type: 'trace_gift_play_success',
            content: '',
            gift_url_type: 'svga',
            gift_url: url,
            room_id: room.getRoomId(),
            platform: 'PC',

            frame_count: videoItem.frames,
            preset_fps: videoItem.FPS,
            play_frame_count: framePlayCount,
            play_time: Date.now() - sTime,
            play_percentage: (
              (framePlayCount / videoItem.frames) *
              100
            ).toFixed(2),
          });
        });
        onReady && onReady(player, videoItem);

        player.startAnimation();
      },
      function (err) {
        onStop && onStop();

        track.send({
          event: 'trace_gift_play',
          event_type: 'trace_gift_play_failed',
          content: '',
          gift_url_type: 'svga',
          gift_url: url,
          room_id: room.getRoomId(),
          platform: 'PC',
        });
      },
    );
  } catch (e) {
    console.error('svga play error', {
      url,
      domId,
    });
  }

  return player;
};

export default {
  play,
};
